import { put, call, takeLatest, select } from 'redux-saga/effects';

import { ADVOCACY_STATUS_QUERY_KEY } from 'hooks/linkedinAdvocacy/useAdvocacyStatus';
import { getLinkedinConnectionStatus, verifyCodeLinkedin } from 'services/linkedin';
import { AsyncAction } from 'types/Action';
import { Store } from 'types/store/Store';
import {
  VerifyCodeLinkedinMeta,
  VerifyCodeLinkedinPayload,
} from 'types/store/VerifyCodeLinkedin';
import { queryClient } from 'utils/QueryClient';

import { getLinkedinConnectionStatusActions, verifyCodeLinkedinActions } from '../actions';

export function* verifyCodeLinkedinRequest(
  action: AsyncAction<VerifyCodeLinkedinMeta, VerifyCodeLinkedinPayload>,
): any {
  const state: Store = yield select();
  if (state.auth.token) {
    try {
      const { data } = yield call(
        verifyCodeLinkedin,
        action.meta,
        state.auth.token,
      );
      yield put(verifyCodeLinkedinActions.success(data));
      // Landing navigates on without waiting for this exchange, so the reconnect
      // banner may already hold, or be fetching, the pre-connect answer. An
      // invalidation alone would reuse a first request still in flight.
      yield call(
        [queryClient, queryClient.cancelQueries],
        ADVOCACY_STATUS_QUERY_KEY,
      );
      yield call(
        [queryClient, queryClient.invalidateQueries],
        ADVOCACY_STATUS_QUERY_KEY,
      );
    } catch (e: any) {
      yield put(verifyCodeLinkedinActions.failed(e.message));
    }
  }
}

function* verifyCodeLinkedinSuccess(action: AsyncAction<VerifyCodeLinkedinMeta, VerifyCodeLinkedinPayload>): any {
  const state: Store = yield select();

  const { data } = yield call(
    getLinkedinConnectionStatus,
    action.meta,
    state.auth.token,
  );

  yield put(getLinkedinConnectionStatusActions.success(data));
}

function* verifyCodeLinkedinWatcher(): any {
  yield takeLatest(
    verifyCodeLinkedinActions.REQUEST,
    verifyCodeLinkedinRequest,
  );
  yield takeLatest(verifyCodeLinkedinActions.SUCCESS, verifyCodeLinkedinSuccess);
}

export default verifyCodeLinkedinWatcher;
